
export const TRACK_CELL_TARGETS = Object.freeze({
    DETAILS: 'details',
    PLAY: 'play',
});
